/*
 * @Descripttion: 
 * @version: 
 * @Author: dingzhaowei
 * @Date: 2024-04-07 13:47:18
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-09 17:06:21
 * @FilePath: \mobile-portal\src\global\axios.js
 */

// import Vue from 'vue';
import { Toast, Dialog} from 'vant';
import axios from 'axios';
import store from '../store';
import { logout } from '../utils/autoLogin';
import auth from '../utils/index';
import router from '../router/router';

// import Qs from 'qs';
// import { toPairs, each, isArray } from 'lodash';
// import router from '../router/router';
// import '../styles/common.styl';

axios.defaults.withCredentials = false;
let updateToken = false;

// const CACHE = new Map();
// const HEADER = { CACHE: 'X-Cache', QUIET: 'X-Quiet' };
// create an axios instance
const service = axios.create({
  // api的base_url
  baseURL: window.BASE_API,
  // request timeout
  timeout: 300000,
});

service.interceptors.request.use((config) => {
  config.baseURL = window.BASE_API;
  if (window.BASE_API && (config.url.indexOf(window.BASE_API) === -1 && config.url.indexOf('http') === -1)) {
    //config.url = window.BASE_API + config.url;
  }

  const paiToken = auth.getStorageByKey('PAI-token');
  if (paiToken) {
    config.headers.Token = `${JSON.parse(paiToken)}`;
    return config;
  }
  return config;
}, Promise.reject);

const isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 判断移动端类型
const isWeCom= /wxwork/i.test(navigator.userAgent); // 判断是否为企业微信类
        
service.interceptors.response.use((resp) => {
  const { status, data } = resp;
  if (status === 200) {
    // 成功状态码
    if (!data.responseCode || data.responseCode === '100') {
      //token过期
      if(data.code==402){
        if((isWeCom && isMobile)||(isWeCom && !isMobile)){
          let userName = JSON.parse( auth.getStorageByKey('PAI-account')).UserName;
          if(userName){
            store.dispatch('RequestToken',userName).then((response)=>{
              localStorage.setItem('PAI-token', JSON.stringify(response.data))
              localStorage.setItem('Login-time', new Date().getTime());
              router.push({name:'home'});
            })
          }else{
            router.replace({path:'/login'});
            return Promise.resolve(data);
          }
        }else{
          Dialog({
            message: data.msg,
          }).then(() => {
            router.replace({path:'/login'});
          });
        }
      }else if(data.code==500){
        this.$notify({
          type: 'warning',
          message: 'Connection exception, please contact the system administrator.',
          duration:0,
        })
      }else{
          return Promise.resolve(data);
      }
    } else if (data.responseCode === '300') {
      setTimeout(() => {
        Toast.fail(data.messageList[0].message);
      }, 1000);
    } else if (data.responseCode === '605') {
      const paiToken = auth.getStorageByKey('PAI-token');
      if (paiToken && !updateToken) {
        updateToken = true;
        const tokenPro = store.dispatch('UpdateToken', JSON.parse(paiToken).refresh_token);
        tokenPro.then((res) => {
          if (res) {
            auth.setStorageByKey('PAI-token', JSON.stringify(res.token));
            auth.setStorageByKey('Login-time', new Date().getTime());
            updateToken = false;
          }
        });
      }
    }
  }
  return Promise.reject(resp);
}, (err) => {
  Toast.fail('Service exception!');
  throw err;
});
export default service;
